import { useState } from "react";
import { sendEmail } from "../../../api/contacts";
import toast from "react-hot-toast";
import { FiSend } from "react-icons/fi";

export default function CategorySend({ token, categories, templateId, setResult, trackOpens = false, includeUnsubscribe = false }) {
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await sendEmail(token.access, category, templateId, trackOpens, includeUnsubscribe);
      setResult(res);
      toast.success("Emails sent!");
    } catch {
      toast.error("Failed");
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSend} className="bg-white p-6 rounded-lg shadow-sm border space-y-4">
      <label className="text-sm font-semibold">Select Category</label>
      <select
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        className="border p-3 rounded w-full"
        required
      >
        <option value="">-- Select --</option>
        {categories.map((c) => (
          <option key={c.category} value={c.category}>
            {c.category} ({c.count})
          </option>
        ))}
      </select>

      <button
        type="submit"
        className="bg-blue-600 text-white px-6 py-2 rounded flex items-center gap-2"
        disabled={loading}
      >
        <FiSend /> {loading ? "Sending..." : "Send"}
      </button>
    </form>
  );
}
